<template>
<div>
    <div class="emotiwidget-container">
      <div class="emoticon"  :class="{'user-has-selected': choosenIcon.id!=0}" @click="toggleShow">
        <div ref="current-icon" class="unicode" v-html="choosenIcon.code"></div>
        <div v-if="choosenIcon.id!=0" class="counter">{{choosenIcon.count}}</div>
      </div>
      <div ref="icon-selector" class="icon-selector">
        <div class="emoticon smaller"  v-for="(item,index) in emoticons" :key="index" :class='{"selected-icon":index==choosenIcon.id-1}' @click="selectIcon(item)">
          <div class="unicode" v-html="item.code"></div>
          <div class="counter">{{item.count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

// EMITS: '@selected' => id
// 0 is nothing selected.


export default {
  name: 'emoticon-select',
  props:{
    userChoice:{
      type:Number,
      default:0
      },
    counters:{
      type:Object,
      default:()=>{return {}},
    }
  },
  data:function(){
    return {
      show:false,
      iconSelector:undefined,
      currentIcon:undefined,
      choosenIcon:{ id:0,name:"thumbs up", code:"&#128077;",count:0},
      emoticons:[
          { id:1, name:"thumbs up", code:"&#128077;",count:0},
          { id:2, name:"hartje", code:"&#10084;&#65039;",count:0},
          { id:3, name:"hard lachen", code:"&#128514;",count:0},
          { id:4, name:"geschrokken", code:"&#128561;",count:0},
          { id:5, name:"hard huilen", code:"&#128557;",count:0},
          { id:6, name:"boos", code:"&#128544;",count:0},
        ]
    }
  },
  components:{
    
  },
  methods:{
    selectIcon(selectedIcon){
      // user selected an emoticon
      this.toggleShow();

      var selected_id=selectedIcon.id;
      var selected_code=selectedIcon.code;
      
      var icon;

      if(selectedIcon.id==this.choosenIcon.id)
      {
        // count down previous selected
        icon=this.emoticons.find(emoticon=>emoticon.id===selectedIcon.id);
        icon.count--;

        // deselect choice
        selected_id=0
        selected_code="&#128077;";
        
        this.choosenIcon.id=selected_id;
        this.choosenIcon.code=selected_code;
        this.choosenIcon.count=0;
      }else{
        // count up this selected
        icon=this.emoticons.find(emoticon=>emoticon.id===selectedIcon.id);
        icon.count++;

        this.choosenIcon.count=icon.count;
        // count down previous
        if(this.choosenIcon){
          icon=this.emoticons.find(emoticon=>emoticon.id===this.choosenIcon.id);
          if(icon){
            icon.count--;
          }
          
        }
        
      }

         this.$emit("selected",selected_id);

        anime({
              targets: this.currentIcon,
              opacity: 0,
              scale:0,
              duration:250,
              easing: 'easeOutSine',
            }).finished.then(()=>{

              this.choosenIcon.id=selected_id;
              this.choosenIcon.code=selected_code;

              anime({
                targets: this.currentIcon,
                opacity: 1,
                scale:1,
                duration:250,
                easing: 'easeInSine',
              })

          })
       
      
      

    },
     showicons(){
       anime.remove(this.iconSelector);
       this.iconSelector.style.transform="scale(0)"; /* animejs workaround, for scaling happen first time*/
       anime({
          targets: this.iconSelector,
          opacity: 1,
          scale:1,
          duration:550,
          easing: 'easeOutElastic',
        })
     },
     hideIcons(){
       anime.remove(this.iconSelector)
       anime({
          targets: this.iconSelector,
          opacity: 0,
          scale:0,
          duration:250,
          easing: 'easeOutSine',
        })
     },
     toggleShow(){
       
       this.show=!this.show;
       this.show ? this.showicons():this.hideIcons();
     },
     initEmoticons(){
       
       var icon;

        // initialize counters
        for(var key in this.counters){
          icon=this.emoticons.find(emoticon=>emoticon.id===parseInt(key));
          if(icon){
            icon.count=parseInt(this.counters[key]);
          }
        }

         // find loaded emoticon
        icon=this.emoticons.find(emoticon=>emoticon.id===this.userChoice);
        
        if(icon){
          this.choosenIcon.id=icon.id;
          this.choosenIcon.code=icon.code;
          this.choosenIcon.count=icon.count;
        }

        
     }
  },
  computed:{
  
  },
  mounted:function(){
    this.iconSelector=this.$refs['icon-selector'];
    this.currentIcon=this.$refs['current-icon'];
    this.initEmoticons();
  },
  watch:{
   userChoice:function(){ // (oldvar,newvar)
      this.initEmoticons();
   }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.emotiwidget-container{
  margin:10px 0px;
  position:relative;
  display:inline-flex;
  padding:2px;
  justify-content: center;
  align-items: center;
}
.emoticon{
  cursor:pointer;
  position:relative;
    width:38px;
    height:38px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #EEEEEE;
    border-radius: 2px;
    font-size:1.5em;
    margin-right:5px;
    border:1px solid transparent;
    transition:border .35s;
}
.smaller{
  width:34px;
  height:34px;
  font-size:1.4em;
}


.emoticon:last-child{
   margin-right:0px;
}
.unicode{
  position:absolute;
  font-size:inherit;
}
.counter{
  position:absolute;
  right:2px;
  bottom:2px;
  font-size:.3em;
  background-color:rgba(255,255,255,.75);
  padding:1px;
  border-radius:2px;
}
.user-has-selected{
   border:1px solid black;
}
.icon-selector{
  opacity:0;
  transform:scale(0);
  display:inline-flex;
  transform-origin: left center;
}
.selected-icon{
  border:1px solid black;
}
</style>

